import type { User } from 'src/admin/users/types';
import useUsers from 'src/admin/users/hooks/useUsers';

export const isSelectableAdvisor = (advisor: User) =>
  advisor.userStatus !== 'DEACTIVATED' && advisor.userStatus !== 'ARCHIVED';

export const useAdvisors = (enabled = true) => {
  const { users, isLoading, refetch } = useUsers(
    ['ADVISOR', 'SYSTEM_ADMIN', 'SERVICE_ADMIN'],
    !enabled,
  );

  return {
    advisors: users,
    isLoading,
    refetch,
  };
};
